export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7865.2c066f99.jpg";